import React, { createContext, useState, useContext } from "react";
import { GlobalContext } from "./GlobalState";
import workspaces from "../services/api/workspaces";

export const RoleContext = createContext();

//--------------------------------------
export const RoleProvider = ({ children }) => {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [createdInvite, setCreatedInvite] = useState({ role: "member" });
  const [invitationEmail, setInvitationEmail] = useState("");

  const { currentWorkspace } = useContext(GlobalContext);

  const getWorkspaceUsers = async () => {
    try {
      const userData = await workspaces.getUsers({ id: currentWorkspace.id });
      const invites = await workspaces.pendingInvites({
        id: currentWorkspace.id,
      });
      const userArray = userData.data;
      const users = userArray.map((user) => {
        let userObject = {
          id: user._id,
          firstName: user.firstName,
          lastName: user.lastName,
          role: user.workspaces[currentWorkspace.id].role,
          isActive: user.workspaces[currentWorkspace.id].status === "active",
          emailAddress: user.emailAddress,
        };
        return userObject;
      });
      const invitesObject = invites.data;

      let invitesArray = [];
      if (typeof invitesObject === 'object') {
        for (let [key, value] of Object.entries(invitesObject)) {
          const emailPeriod = key.replace(',', '.');
          const pendingUsers = {
            firstName: "Invite",
            lastName: "Pending",
            emailAddress: emailPeriod,
            role: value.role,
          };
          invitesArray.push(pendingUsers);
        }
      }

      const combinedArray = users.concat(invitesArray);
      setUsers(combinedArray);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <RoleContext.Provider
      value={{
        users,
        getWorkspaceUsers,
        selectedUser,
        setSelectedUser,
        createdInvite,
        setCreatedInvite,
        invitationEmail,
        setInvitationEmail,
      }}
    >
      {children}
    </RoleContext.Provider>
  );
};
